import React, { Component } from 'react';
import Session from 'components/Session';
import { logPageView, initGA } from 'utils/analytics';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { ViewAthlete, VerifyCoach, AdminBase, CoachDashboard } from 'routes/routeNames';

class Redirect extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    history: PropTypes.shape(),
  };
  static defaultProps = {
    attributes: {},
    push: PropTypes.func.isRequired,
    history: {
      push: () => {},
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  componentWillMount() {
    if (this.props.attributes.size > 0) {
      if (this.props.attributes.get('zoneinfo') === 'COACH') {
        this.props.history.push(VerifyCoach);
      } else if (this.props.attributes.get('zoneinfo') === 'ADMIN') {
        this.props.history.push(AdminBase);
      } else if (this.props.attributes.get('zoneinfo') === 'STUDENT') {
        this.props.history.push(ViewAthlete);
      }
    }
  }

  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.attributes.size > 0) {
      if (nextProps.attributes.get('zoneinfo') === 'COACH' && nextProps.attributes.get('profile') !== 'PENDING') {
        this.props.history.push(CoachDashboard);
      } else if (nextProps.attributes.get('zoneinfo') === 'COACH' && nextProps.attributes.get('profile') === 'PENDING') {
        this.props.history.push(VerifyCoach);
      } else if (nextProps.attributes.get('zoneinfo') === 'ADMIN') {
        this.props.history.push(AdminBase);
      } else if (nextProps.attributes.get('zoneinfo') === 'STUDENT') {
        this.props.history.push(ViewAthlete);
      }
    }
  }

  render() {
    return (
      <div />
    );
  }
}

export default Session(Redirect);




// WEBPACK FOOTER //
// ./src/containers/Redirect/Redirect.js